import { render } from "./MinistryDashboard.vue?vue&type=template&id=2497c170&scoped=true"
import script from "./MinistryDashboard.vue?vue&type=script&lang=js"
export * from "./MinistryDashboard.vue?vue&type=script&lang=js"

import "./MinistryDashboard.vue?vue&type=style&index=0&id=2497c170&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2497c170"]])

export default __exports__